<template>
  <div class="bodyMess">
    <div class="Mess_tip">
      <el-breadcrumb separator-icon="ArrowRight">
        <el-breadcrumb-item :to="{ path: '/' }">当前位置 : 首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Bidding' }">招标公告</el-breadcrumb-item>
        <el-breadcrumb-item>正文</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="bidding_content_mesage">
      <div v-for="i in loadData" :key="i.tbId" style="padding-bottom: 40px;cursor: pointer;" @click="AnnouncementDetails(i.bulletinType,i.tbId)">
        <div class="mesage_title">
          <div style="display: flex;align-items: center;">
            <div style="background: rgba(0, 82, 136, 1);color: #fff;padding: 5px;">{{i.bulletinTypeName}}</div>
            <div style="display: flex;margin-left: 10px;">
              <div>{{i.bulletinName}}</div>
              <div style="color: rgb(255, 84, 84);">【剩余<span>{{ i.residueDays == -1 ? "0" : i.residueDays  }}</span> 天】</div>
            </div>
          </div>
          <div style="color: rgba(153, 153, 153, 1);">{{ i.publishTime ? i.publishTime.slice(0, 11) : ''  }}</div>
        </div>
        <div class="mesage_content">
          <div class="color">公告详情：</div>
          <div class="overflow" v-html="$options.filters.ellipsis(i.bulletinContent)"></div>
        </div>
        <div class="mesage_bottom">
          <div class="display">
            <div class="color">项目类型：</div>
            <div class="color1">{{i.tdrPrjClassifyName}}</div>
          </div>
          <div class="display">
            <div class="color">项目所在地：</div>
            <div class="color1">{{i.regionName}}</div>
          </div>
          <div class="display">
            <div class="color">项目来源：</div>
            <div class="color1">{{i.businessTypeName}}</div>
          </div>
        </div>
      </div>
      <div style="display: flex;justify-content: end;">
        <el-pagination v-model:currentPage="currentPage" v-model:page-size="pageSize" :page-sizes="[10, 20, 40]" :disabled="disabled" layout="total, sizes, prev, pager, next, jumper" :total="Total"
          background @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>
  </div>
</template>
<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import inspect from '@/api/validate'
import { pageFindTenderBulletinList } from '@/api/index.js';
export default {
  filters: {
    ellipsis(value) {
      value = value.replace(/<\/?.+?>/g, "");
      value = value.replace(/ /g, " ");
      value = value.replace(/.*?\}/g, " ");
      value = value.replace(/.*?\}/g, "");
      return value;
    },
  },
  setup() {
    const router = useRouter();
    const disabled = ref()
    const bulletinType = ref()
    const currentPage = ref(1)
    const pageSize = ref(10)
    const tbId = ref()
    const loadData = ref([])
    const Total = ref(1)
    const keyWord = ref()
    const NewsTitle = async () => {
      const rows = await pageFindTenderBulletinList({ currentPage: currentPage.value || 1, pageSize: pageSize.value || 10, keyWord: keyWord.value })
      Total.value = rows.total
      loadData.value = rows.rows
      console.log(loadData, 'loadData');
    }
    const AnnouncementDetails = (Type, Id) => {
      router.push({ path: '/AnnouncementDetails', query: { bulletinType: Type, tbId: Id } })
    }
    const handleSizeChange = (val) => {
      pageSize.value = val
      NewsTitle()
    }
    const handleCurrentChange = (val) => {
      currentPage.value = val
      NewsTitle()
    }
    onMounted(async () => {
      keyWord.value = router.currentRoute.value.query.keyWord;
      await NewsTitle()
    })
    return {
      disabled,
      bulletinType,
      currentPage,
      pageSize,
      loadData,
      tbId,
      Total,
      keyWord,
      NewsTitle,
      AnnouncementDetails,
      handleSizeChange,
      handleCurrentChange
    };
  },
  methods: {
    // 获取列表ID对应的市
    getArrName(val, child) {
      const resp = inspect.getFullTreeName(val, child)
      if (resp.valArray) {
        return resp.valArray.join('')
      }
    },
    // 获取项目类型
    projectType(id, array) {
      // this.loading = true
      for (let i = 0; i < array.length; i++) {
        if (array[i].value == id) {
          return array[i].label // 如果找到匹配的ID，返回该对象
        }
        if (array[i].children) {
          const result = this.projectType(id, array[i].children) // 递归查找子对象数组
          if (result) {
            return result // 如果在子数组中找到匹配的ID，返回该对象
          }
        }
        // this.loading = false
      }
      // this.loading = false
      return null // 如果没有找到匹配的ID，返回null
    },
  }
};
</script>
<style>
@import url("./bodyMes.css");
a {
  text-decoration: none;
}
.el-descriptions__body {
  background: rgba(245, 247, 250, 1);
}
</style>